module.exports = "https://trybtryb-legacy.web.app/img/fees.45600095.svg";